<template>
  <section>
    <!-- "header" content other pages -->
    <header-content-geral
      :topSpace="busTopSpace"
    />

    <!-- content -->
    <content-shopkeeper />
  </section>
</template>

<script>
// shopkeeper
import Content from '@/components/shop-keeper/Content.vue'

// all
import HeaderContentGeral from '@/components/HeaderContentGeral'

export default {
  props: {
    busTopSpace: {
      type: String, 
      required: true
    }
  },
  components: {
    'header-content-geral': HeaderContentGeral,
    'content-shopkeeper': Content
  }
}
</script>
